import React, { useState } from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import varifiedIcon from "../../../assests/verifiedIcon.svg";
import './SubCategoryForm.css';

const SubCategoryCreateComponent = ({
  formData,
  imagePreview,
  isSubmitting,
  isFormValid,
  category,
  onChange,
  onStatusChange,
  onImageChange,
  onSubmit,
  onBack,
  fileInputRef,
  showSuccessPopup,
  onSuccessClose,
  createdItemName,
  createdItemId,
}) => {
  const [dragActive, setDragActive] = useState(false);

  const handleImageSelect = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onImageChange(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    const file = e.dataTransfer.files?.[0];
    if (file) {
      onImageChange(file);
    }
  };

  const handleRemoveImage = (e) => {
    e.stopPropagation();
    onImageChange(null);
  };

  return (
    <div className="subcategory-form-container">
      <Sidebar />
      
      {isSubmitting && (
        <div className="full-page-loader">
          <div className="spinner"></div>
        </div>
      )}
      
      <div className="subcategory-form-content">
        <div className="subcategory-form-header">
          <button className="subcategory-form-back-btn" onClick={onBack}>
            ←
          </button>
          <h1>Sub Category Creation</h1>
           <div >
              <span className="parent-label">Parent Category:</span>
              <span className="parent-name">{category?.name}</span>
            </div>
        </div>

        <div className="subcategory-form-wrapper">
          <div className="subcategory-form-card">
            {/* Parent Category Info */}
           

            <form onSubmit={onSubmit}>
              {/* Sub Category Name Field */}
              <div className="subcategory-form-group">
                <label className="subcategory-form-label">
                  Sub Category Name <span className="subcategory-required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={onChange}
                  placeholder="Eg. Wireless Headphones, Smartphones"
                  className="subcategory-form-input"
                />
              </div>

              {/* Description Field */}
              <div className="subcategory-form-group">
                <label className="subcategory-form-label">Description (Optional)</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={onChange}
                  placeholder="Brief summary of sub-category"
                  className="subcategory-form-textarea"
                  rows="3"
                />
              </div>

              {/* Status Field */}
              <div className="subcategory-form-group">
                <label className="subcategory-form-label">Status</label>
                <div className="subcategory-status-buttons">
                  <button
                    type="button"
                    className={`subcategory-status-btn ${formData.status === 'active' ? 'subcategory-status-active' : ''}`}
                    onClick={() => onStatusChange('active')}
                  >
                    Active
                  </button>
                  <button
                    type="button"
                    className={`subcategory-status-btn ${formData.status === 'inactive' ? 'subcategory-status-inactive' : ''}`}
                    onClick={() => onStatusChange('inactive')}
                  >
                    Inactive
                  </button>
                </div>
              </div>

              {/* Image Upload Field */}
              <div className="subcategory-form-group">
                <label className="subcategory-form-label">Image</label>
                <div 
                  className={`subcategory-image-upload-area ${dragActive ? 'subcategory-drag-active' : ''}`}
                  onClick={() => fileInputRef.current?.click()}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept="image/*"
                    onChange={handleImageSelect}
                  />
                  {imagePreview ? (
                    <div className="subcategory-image-preview-container">
                      <img src={imagePreview} alt="Preview" className="subcategory-image-preview" />
                      <button 
                        type="button"
                        className="subcategory-remove-image-btn"
                        onClick={handleRemoveImage}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div className="subcategory-upload-placeholder">
                      <div className="subcategory-upload-icon">📤</div>
                      <p className="subcategory-upload-text">
                        <span className="subcategory-browse-link">Choose file</span> or drag here
                      </p>
                      <p className="subcategory-upload-hint">Png, Jpg, up to 5MB</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="subcategory-form-actions">
                <button 
                  type="button" 
                  className="subcategory-cancel-btn"
                  onClick={onBack}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className={`subcategory-submit-btn ${isFormValid ? 'subcategory-active' : 'subcategory-disabled'}`}
                  disabled={!isFormValid || isSubmitting}
                >
                  {isSubmitting ? 'Creating...' : 'Create Sub Category'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="subcategory-success-overlay">
          <div className="subcategory-success-modal">
            <div className="subcategory-success-icon">
              <img style={{width:"100%", height:"100%"}} src={varifiedIcon} alt="success" />
            </div>
            <h3 className="subcategory-success-title">Created Successfully!</h3>
            <p className="subcategory-success-message">Sub category has been created successfully.</p>
            
            <div className="subcategory-success-details">
              <div className="subcategory-success-detail-row">
                <span className="subcategory-success-label">Name:</span>
                <span className="subcategory-success-value">{createdItemName}</span>
              </div>
              <div className="subcategory-success-detail-row">
                <span className="subcategory-success-label">ID:</span>
                <span className="subcategory-success-value">{createdItemId}</span>
              </div>
              <div className="subcategory-success-detail-row">
                <span className="subcategory-success-label">Parent Category:</span>
                <span className="subcategory-success-value">{category?.name}</span>
              </div>
            </div>
            
            <button 
              className="subcategory-success-btn" 
              onClick={onSuccessClose}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubCategoryCreateComponent;